import { t } from 'i18next'
import { currentLang } from './localization/currentLang'

export function initChat() {
  function loadGetCallWidget(widgetHash) {
    const addCallWidgetScript = (document, widgetHash, onLoadCallback) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = `//widgets.binotel.com/getcall/widgets/${widgetHash}.js`
      script.onload = onLoadCallback

      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    }

    const handleButtonClick = () => {
      const phoneExampleInterval = setInterval(() => {
        const phoneExampleBlock = document.getElementById('bingc-phone-sample')
        if (phoneExampleBlock) {
          clearInterval(phoneExampleInterval) /* Stop checking */

          phoneExampleBlock.innerHTML =
            t('add_country_code') + ' ' + phoneExampleBlock.innerHTML

          phoneExampleBlock.classList.add('bingc-phone-wrapper')
        }
      }, 500) /* Check every 500 ms */
    }

    const onWidgetLoaded = () => {
      const intervalId = setInterval(() => {
        const button = document.querySelector('.bwc-get-call')
        if (button) {
          clearInterval(intervalId) /* Stop checking when the button is found */
          button.addEventListener('click', handleButtonClick)
        }
      }, 500) /* Check every 500 ms */
    }

    addCallWidgetScript(document, widgetHash, onWidgetLoaded)
  }

  function loadGetChatWidget(widgetHash) {
    const addChatWidgetScript = (document, widgetHash) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = `//widgets.binotel.com/chat/widgets/${widgetHash}.js`
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    }

    addChatWidgetScript(document, widgetHash)
  }

  /* Define `widgetHash` for each language */
  const languageSettings = {
    en: {
      callWidgetHash: '7n470ny9qljh95qfqoyb',
      chatWidgetHash: 'dr7vuI0PhhGoLocQot8e',
    },
    pl: {
      callWidgetHash: '3vs0pcoqlq18070e1rm9',
      chatWidgetHash: 'AMVqpJzCr1Ynhwb0KCwe',
    },
    ua: {
      callWidgetHash: 'jl6ti5n3iz3dwzsg4osv',
      chatWidgetHash: 'W29p3ZnxQFkdQBRPpcmI',
    },
    kz: {
      callWidgetHash: 'qz0egddbhcprshcx1a30',
      chatWidgetHash: 'B7xkC1nR9lU4DBLjlbhu',
    },
    rus: {
      callWidgetHash: 'fh6d1zussh4g3zux6rw4',
      chatWidgetHash: 'B7xkC1nR9lU4DBLjlbhu',
    },
    lv: {
      callWidgetHash: '5pf9t9syxgj63izpuwo7',
      chatWidgetHash: 'dr7vuI0PhhGoLocQot8e',
    },
    lt: {
      callWidgetHash: '0h98jzvw8l8km7qqn8i2',
      chatWidgetHash: 'uBQdZTUjNqc1YZqZwDI1',
    },
    ge: {
      callWidgetHash: 'yjdtfvzphz68u9kr3o37',
      chatWidgetHash: 'dr7vuI0PhhGoLocQot8e',
    },
    se: {
      callWidgetHash: 'vega91si79crmno0whtq',
      chatWidgetHash: 'dr7vuI0PhhGoLocQot8e',
    },
  }

  /* Retrieve the current language and get settings for it */
  const settings = languageSettings[currentLang] || languageSettings.en

  /* Call the function to initialize the call widget */
  loadGetCallWidget(settings.callWidgetHash)
  /* Call the function to initialize the chat widget */
  loadGetChatWidget(settings.chatWidgetHash)
}
